import React from "react";
import Table from "rc-table";
import type { ColumnsType } from "rc-table/es/interface";
import type { TableProps } from "rc-table/es/Table";

import "./ls-table.css";
import DataTableSkeleton from "./DataTableSkeleton";

export type DataTableProps<RecordType extends object> = Omit<
  TableProps<RecordType>,
  "prefixCls"
> & {
  columns: ColumnsType<RecordType>;
  data: readonly RecordType[];
  /** Optional loading state to show table skeleton. */
  loading?: boolean;
  skeletonRows?: number;
  skeletonColumns?: number;
};

/**
 * Thin rc-table wrapper with project styling.
 * Keep usage close to docs: pass columns/data/render directly.
 */
export default function DataTable<RecordType extends object>({
  columns,
  data,
  loading = false,
  skeletonRows = 8,
  skeletonColumns,
  ...rest
}: DataTableProps<RecordType>) {
  const colCount = skeletonColumns ?? columns?.length ?? 1;

  if (loading) {
    return <DataTableSkeleton columnCount={colCount} rowCount={skeletonRows} />;
  }

  return <Table<RecordType> prefixCls="ls-table" columns={columns} data={data} {...rest} />;
}
